<script>
// 仅导入父组件，无需导入Draw
import DrawBase from './drawBase.vue';
import UtilS from '@/utils/MapUtil.js';

export default {
    extends: DrawBase,
    data() {
        return {
            styleLineString: null,
        };
    },
    render() {
        return null;
    },
    watch: {
        selectLDrawType: {
            handler(type) {
                if (this.geometryType === 'LineString' && type) {
                    this.initMap()
                        .then(() => {
                            if (this.map && this.VectorSource) {
                                this.onAddInteraction();
                            } else {
                                console.error('地图或数据源初始化失败，无法创建Draw交互');
                            }
                        })
                        .catch((err) => {
                            console.error('初始化地图失败：', err);
                        });
                }
            },
            immediate: true,
        },
    },
    methods: {
        // LineString专用样式函数
        styleFunction(feature, resolution) {
            let styles = [];
            const type = this.selectLDrawType;

            // 风向样式
            if (type === 'wind') {
                const geometry = feature.getGeometry();
                styles = [
                    this.createOLStyle({
                        stroke: this.createOLStroke({
                            color: '#29FFF288',
                            width: 8,
                            lineCap: 'butt',
                            zIndex: 20,
                        }),
                    }),
                ];

                // 起点和终点箭头
                const coords = geometry.getCoordinates();
                if (coords.length >= 2) {
                    // 终点箭头
                    const last = coords[coords.length - 1];
                    const last2 = coords[coords.length - 2];
                    const dx = last2[0] - last[0];
                    const dy = last2[1] - last[1];
                    const rotationLast = -Math.atan2(dy, dx);

                    // 起点箭头
                    const first = coords[0];
                    const first2 = coords[1];
                    const rotationFirst = -Math.atan2(first[1] - first2[1], first[0] - first2[0]);

                    styles.push(
                        this.createOLStyle({
                            geometry: this.createOLPoint(last),
                            image: this.createOLIcon({
                                src: require('../images/up.png'),
                                anchor: [1, 0.5],
                                rotateWithView: true,
                                rotation: rotationLast,
                            }),
                            zIndex: 21,
                        }),
                        this.createOLStyle({
                            geometry: this.createOLPoint(first),
                            image: this.createOLIcon({
                                src: require('../images/bottom.png'),
                                anchor: [0.01, 0.5],
                                rotateWithView: true,
                                rotation: rotationFirst,
                            }),
                            zIndex: 21,
                        }),
                    );

                    this.styleLineString = { rotationFirst, CoordinatesFirst: first };
                }
            }
            // 交通管制道路样式
            else if (type === 'Traffic-road') {
                const geometry = feature.getGeometry();
                if (!geometry.getLength) return styles;

                // 基础线条
                styles.push(
                    this.createOLStyle({
                        stroke: this.createOLStroke({
                            color: '#FF3D0088',
                            width: 15,
                            lineCap: 'butt',
                        }),
                        zIndex: 21,
                    }),
                );

                // 箭头计算
                const length = geometry.getLength();
                const step = 40; // 箭头间隔（像素）
                const StepLength = step * resolution; // 实际距离
                const arrowNum = Math.floor(length / StepLength);

                const rotations = [];
                const distances = [0];
                geometry.forEachSegment((start, end) => {
                    const dx = end[0] - start[0];
                    const dy = end[1] - start[1];
                    rotations.push(Math.atan2(dy, dx));
                    distances.unshift(Math.sqrt(dx ** 2 + dy ** 2) + distances[0]);
                });

                // 添加箭头
                for (let i = 1; i < arrowNum; ++i) {
                    const arrowCoord = geometry.getCoordinateAt(i / arrowNum);
                    const d = i * StepLength;
                    const grid = distances.findIndex((x) => x <= d);
                    styles.push(
                        this.createOLStyle({
                            geometry: this.createOLPoint(arrowCoord),
                            image: this.createOLIcon({
                                src: require('../images/icon-road.png'),
                                opacity: 1,
                                anchor: [0.5, 0.5],
                                rotateWithView: false,
                                rotation: -rotations[distances.length - grid - 1],
                                scale: 0.8,
                            }),
                            zIndex: 22,
                        }),
                    );
                }
            }

            return styles;
        },

        // LineString绘制交互（调用父组件createOLDraw方法）
        onAddInteraction() {
            if (!this.map) {
                console.error('map 实例不存在，无法添加 Draw 交互');
                return;
            }
            if (!this.VectorSource) {
                console.error('VectorSource 不存在，无法创建 Draw 交互');
                this.VectorSource = this.createOLVectorSource({ wrapX: false });
            }

            this.removeDraw();

            try {
                // 调用父组件封装的Draw创建方法
                this.draw = this.createOLDraw({
                    type: 'LineString',
                    style: this.styleFunction.bind(this),
                });

                this.map.addInteraction(this.draw);
                this.bindDrawEndEvent();
            } catch (err) {
                console.error('创建 Draw 交互失败：', err);
                this.draw = null;
            }
        },

        // 绘制完成事件逻辑
        bindDrawEndEvent() {
            this.draw.on('drawend', async (e) => {
                try {
                    const Coordinates = e.feature.getGeometry().getCoordinates();

                    // 交通管制道路
                    if (this.selectLDrawType === 'Traffic-road') {
                        e.feature.setId(Coordinates[0]);
                        const params = {
                            drawType: 'LineString',
                            drawName: '标记管制路段-道路',
                            drawObj: '管制路段-道路',
                            mark: '道路',
                            positions: Coordinates,
                            color: '#ff3d0088',
                            width: 15,
                        };
                        // this.$emit('addDataEvent', {
                        //     ...params,
                        //     longitude: Coordinates[0],
                        //     latitude: Coordinates[1],
                        // }, 'Traffic-road');
                    }
                    // 风向
                    else if (this.selectLDrawType === 'wind') {
                        e.feature.setId(Coordinates[0]);
                        // 三维数据
                        const three = {
                            feature: {
                                type: 'Feature',
                                geometry: { type: 'LineString', coordinates: Coordinates },
                                properties: null,
                            },
                            subType: 'StraightArrow',
                            options: {},
                            symbol: {
                                lineColor: '#29FFF2',
                                polygonFill: '#29FFF288',
                                polygonOpacity: 0.5,
                            },
                        };
                        // 二维参数
                        const params = {
                            geometryType: 'LineString',
                            name: `标记风向-${new Date().getTime()}`,
                            geometry: UtilS.lineStringToWKT(Coordinates),

                        };
                        this.$emit('addDataEvent', params, 'canvas');
                    }

                    this.emitParentEvents();
                    this.removeDraw();
                } catch (err) {
                    console.error('处理绘制完成事件失败：', err);
                }
            });
        },

    },
};
</script>
